import React from "react";
import PropTypes from "prop-types";
import { useSeriesIndexContext } from "../SeriesIndexApp";

const TAB_COUNT_KEY = {
  active: "activeCount",
  draft: "draftCount",
  archived: "archivedCount",
};

const TabButton = ({ label, tab }) => {
  const ctx = useSeriesIndexContext();
  const selected = ctx.activeTab === tab;
  const count = ctx[TAB_COUNT_KEY[tab]];

  return (
    <button
      type="button"
      onClick={() => ctx.setActiveTab(tab)}
      className={`d-inline-flex align-items-center series-index-tab ${selected ? "series-index-tab-selected" : ""}`}
    >
      <span>{label}</span>
      <span className={`series-index-tab-count ${selected ? "series-index-tab-count-selected" : ""}`}>
        {count}
      </span>
    </button>
  );
};

TabButton.propTypes = {
  label: PropTypes.string.isRequired,
  tab: PropTypes.oneOf(["active", "draft", "archived"]).isRequired,
};

export default TabButton;
